<template>
    <div class="steps">
        <div class="step">
            <span class="el-icon-circle-check step-icon" v-if="active > 1"></span>
            <span class="step-icon pending-icon" v-else-if="active == 1">1</span>
            <span class="step-icon wait-icon" v-else-if="active < 1">1</span>
            <span class="step-title success-title">{{ $t('选择类型') }}</span>
            <div class="line"></div>
        </div>
        <div class="step">
            <span class="el-icon-circle-check step-icon" v-if="active > 2"></span>
            <span class="step-icon pending-icon" v-else-if="active == 2">2</span>
            <span class="step-icon wait-icon" v-else-if="active < 2">2</span>
            <span class="step-title pending-title">{{ $t('填写内容') }}</span>
            <div class="line"></div>
        </div>
        <div class="step">
            <span class="el-icon-circle-check step-icon" v-if="active > 3"></span>
            <span class="step-icon pending-icon" v-else-if="active == 3">3</span>
            <span class="step-icon wait-icon" v-else-if="active < 3">3</span>
            <span class="step-title wait-title">{{ $t('提交成功') }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        active: {
            type: [String, Number],
            default: 2
        },
        title1: {
          type: String,
          default: '选择类型'
        },
        title2: {
            type: String,
            default: '填写内容'
        },
        title3: {
            type: String,
            default: '提交成功'
        }
    },
    data() {
        return {

        }
    }
}
</script>

<style lang="scss" scoped>
.steps {
    display: flex;
    align-items: center;
    .step {
        display: flex;
        align-items: center;
        .el-icon-circle-check {
            font-size: 32px;
            color: #FEE60F;
        }
        .step-icon {
            margin-right: 8px;
        }
        .pending-icon {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            background-color: #FEE60F;
            text-align: center;
            line-height: 32px;
            font-size: 14px;
        }
        .wait-icon {
            width: 32px;
            height: 32px;
            border: 1px solid rgba(0, 0, 0, 0.15);
            text-align: center;
            line-height: 32px;
            border-radius: 50%;
            font-size: 14px;
            color: rgba(0,0,0,0.25);
        }
        .step-title {
            margin-right: 8px;
        }
        .success-title {
            color: #666;
        }
        .line {
           width: 240px;
            height: 1px;
            background-color: rgba(0, 0, 0, 0.15);
            margin-right: 8px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/release/components/steps.vue